import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(["Escuela"]); // Rol por defecto
  const [school, setSchool] = useState({ id: null, name: null }); // Estado para la escuela (id y name)
  const [username, setUsername] = useState(null);
  // Función para obtener y decodificar el token
  const decodeToken = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      

      const decodedAuthorities = decodedToken.authorities || ["Escuela"];
      const decodedSchools = decodedToken.schools || []; // Obtener el array de escuelas
      const decodedUsername = decodedToken.username || decodedToken.sub || null;
      // Si existe el array de schools, obtenemos el id y name de la primera escuela
      const schoolData =
        decodedSchools.length > 0 ? { id: decodedSchools[0].id, name: decodedSchools[0].name } : { id: null, name: null };

      

      setRole(Array.isArray(decodedAuthorities) ? decodedAuthorities : [decodedAuthorities]);
      setSchool(schoolData);
      setUsername(decodedUsername);
      return true;
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  };

  // Verificar si hay un token al cargar la app
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      if (decodeToken(token)) {
        setIsAuthenticated(true);
      } else {
        logout();
      }
    }
  }, []);

  // Función para iniciar sesión
  const login = (token) => {
    localStorage.setItem("accessToken", token);
    if (decodeToken(token)) {
      setIsAuthenticated(true);
    }
  };

  // Función para cerrar sesión
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setIsAuthenticated(false);
    setRole(["Escuela"]);
    setSchool({ id: null, name: null }); // Limpiar el estado de la escuela
    setUsername(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, school, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthProvider = () => useContext(AuthContext);
